/** Mail settings' sections, in order. Shared by the settings page and the
 *  settings nav pane (components/SettingsShell.tsx), which lists them;
 *  the page shows the one named by ?section=. */
import { Bell, Briefcase, HardDrive, ListTree, Mail as MailIcon, Settings as SettingsIcon, Shield, Sparkles, type LucideIcon } from "lucide-react";

export type MailSettingsSection =
  | "display"
  | "ai"
  | "custom-folders"
  | "rules"
  | "team"
  | "retention"
  | "notifications"
  | "jobs";

export const MAIL_SETTINGS_SECTIONS: { id: MailSettingsSection; label: string; icon: LucideIcon }[] = [
  { id: "display", label: "Display", icon: MailIcon },
  { id: "ai", label: "AI", icon: Sparkles },
  { id: "custom-folders", label: "Custom folders", icon: ListTree },
  { id: "rules", label: "Rules", icon: Shield },
  { id: "team", label: "Team members", icon: Briefcase },
  { id: "retention", label: "Folder retention", icon: HardDrive },
  { id: "notifications", label: "Notifications", icon: Bell },
  { id: "jobs", label: "Background jobs", icon: SettingsIcon },
];

export function mailSettingsSection(raw: string | null): MailSettingsSection {
  return MAIL_SETTINGS_SECTIONS.some((s) => s.id === raw) ? (raw as MailSettingsSection) : "display";
}
